import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#171717",
      "fill-rule": "evenodd",
      d: "M4.875 7.5h-.75a.37.37 0 0 0-.375.375v6.75c0 .21.165.375.375.375h.75c.21 0 .375-.165.375-.375v-6.75a.37.37 0 0 0-.375-.375m8.663.75H9.75v-4.5A.75.75 0 0 0 9 3h-.375a.37.37 0 0 0-.375.375V4.5c0 .848-.277 1.628-.75 2.25a4 4 0 0 1-.75.75c-.232.173-.48.322-.75.435V13.5c0 .412.315.75.713.75l5.167.75a.72.72 0 0 0 .675-.51l1.658-5.25c.157-.488-.188-.99-.675-.99",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }